import React from 'react'
import "./SimpleSearchBar.css"

function SimpleSearchBar({searchQuery,setSearchQuery}) {
  return (
           <span className="simple-search-input-container">
            <img src="/img/search.png"  className="simple-search-icon"/>
            <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="simple-search-input"
            />
        </span>
  )
}

export default SimpleSearchBar